@use '~/theme/theme' as *;

.root {
  display: inline-block;
  vertical-align: middle;
}

.xs {
  @include icon-size(xs);
}

.sm {
  @include icon-size(sm);
}

.md {
  @include icon-size(md);
}

.lg {
  @include icon-size(lg);
}

.xl {
  @include icon-size(xl);
}
